<script lang="ts" setup>
  import { h as createElement } from "vue";

  const render = () => {
    return createElement("style", {}, ["", ""]);
  };
</script>

<template>
  <render />
</template>
